import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "verify"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_alert = _resolveComponent("el-alert");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.errorMsg ? (_openBlock(), _createBlock(_component_el_alert, {
    key: 0,
    title: $data.errorMsg,
    type: "error",
    center: "",
    "show-icon": "",
    closable: false
  }, null, 8, ["title"])) : _createCommentVNode("", true)]);
}